/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { formFieldWrapperClasses, getFormFieldStyles } from "./formFieldWrapperStyles";
/** FormFieldWrapper component */
export function FormFieldWrapper(props) {
    const { hideValidationText, formFieldRef, children, label, id, isMobile, isValuePresent, style, hasError, required, disabled } = props;
    const labelProps = { ...FormFieldWrapper.defaultProps.labelProps, ...props.labelProps };
    const warningMessage = props.required ? props.requiredMessage : undefined;
    const warning = calculateIsRequiredAndNotPresent(required, isValuePresent);
    /** Handler to activate Input Element on clicking anywhere within extended border div */
    const onClickFocus = () => {
        if (formFieldRef?.current) {
            formFieldRef?.current.focus();
        }
    };
    const classes = formFieldWrapperClasses;
    const styles = useMemo(() => getFormFieldStyles({
        error: hasError || false,
        isMobile: isMobile,
        label: label,
        disabled: disabled,
        warning: warning,
        labelWidth: labelProps.width,
        labelPosition: labelProps.position,
        required: required
    }), [isMobile, warning, hasError, required, label, disabled, labelProps.width, labelProps.position]);
    return (React.createElement(Box, { id: id, display: "flex", flexDirection: "column", alignItems: "flex-start", style: style, "data-testid": "formfield", sx: styles },
        React.createElement(Box, { className: classes.root },
            React.createElement(Box, { component: "span", className: classes.iconContainer }, hasError ? (React.createElement("span", { "data-testid": "errorIcon", className: classes.errorIcon }, "!")) : (warning && (React.createElement("span", { "data-testid": "warningIcon", className: classes.requiredIcon }, "*")))),
            React.createElement(Box, { onClick: onClickFocus, className: classes.extendedBorder },
                React.createElement(Box, { className: classes.container },
                    !isMobile && label && (React.createElement("label", { className: classes.desktopLabel, htmlFor: props.inputId, id: props.labelId }, label)),
                    children))),
        !hideValidationText && (React.createElement(Box, { className: classes.validationText, height: "1rem" },
            React.createElement("span", { "data-testid": "validationText" }, props.hasError ? props.errorMessage : warning ? warningMessage : undefined)))));
}
//only exporting this function so I can unit test it separately
//if only jest supported same-file tests properly :(
//see: https://github.com/facebook/jest/issues/4316
/**
 * For calculating whether a warning for requiredness needs to be displayed or not.
 * When this is a multi item control (i.e. Multi Select in stories), we just check that there is at least one
 * item in the list. Not clear at this moment whether we should be checking that each item has a value too,
 * and is not relevant to any current use cases anyway.
 * @param required undefined if not required, else contains options for the behaviour of the requiredness check
 * @param value the current value to check requiredness on
 * @returns false if the value is not required or has been provided, otherwise true.
 */
export function calculateIsRequiredAndNotPresent(required, isValuePresent) {
    if (!required) {
        return false;
    }
    else {
        return !isValuePresent;
    }
}
// Default props
FormFieldWrapper.defaultProps = {
    disabled: false,
    required: false,
    hideValidationText: false,
    labelProps: {
        width: "180px",
        position: "left"
    }
};
